import React from 'react';
import Slider from 'react-slick';
import FeaturedBrandCard from '../FeaturedBrandCard/FeaturedBrandCard';
import classNames from 'classnames';

import css from './Sections.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';

export const featuredBrands = [
  {
    name: 'Yumiko',
    image:
      'https://images-platform.99static.com//kZcsNt6tU417nEUv0a8TFEnvzZs=/636x0:1254x618/fit-in/500x500/99designs-contests-attachments/71/71552/attachment_71552376',
    search: '?pub_brand=Yumiko',
  },
  {
    name: 'Eleve',
    image:
      'https://images-platform.99static.com//onrAbXajAowF5UIwoI3l3EzLiM0=/165x1381:1018x2234/fit-in/500x500/99designs-contests-attachments/136/136427/attachment_136427088',
    search: '?pub_brand=Eleve',
  },
  {
    name: 'LuckyLeo',
    image:
      'https://images-platform.99static.com//O1o6S0frqkM_Dnu4nCT7FXP8Kk8=/398x17:1593x1212/fit-in/500x500/99designs-contests-attachments/99/99851/attachment_99851381',
    search: '?pub_brand=Luckyleo-Dancewear',
  },
  {
    name: 'Bloch',
    image:
      'https://images-platform.99static.com//jGqctLDUWB-YIftf0QZLX5FAj3w=/861x0:1431x570/fit-in/500x500/99designs-contests-attachments/77/77444/attachment_77444609',
    search: '?pub_brand=Bloch',
  },
  {
    name: 'Mariia',
    image:
      'https://images-platform.99static.com//em8fXuFGVJOGTE0mVgfyU1A4zIs=/300x153:938x791/fit-in/500x500/99designs-contests-attachments/78/78081/attachment_78081570',
    search: '?pub_brand=Mariia',
  },
  {
    name: 'Ainsliewear',
    image:
      'https://images-platform.99static.com//-h5INvvwqda0ZbPUQRqUagLfFss=/0x0:1000x1000/fit-in/500x500/99designs-contests-attachments/92/92437/attachment_92437917',
    search: '?pub_brand=Ainsliewear',
  },
  {
    name: 'Yumiko',
    image:
      'https://images-platform.99static.com//kZcsNt6tU417nEUv0a8TFEnvzZs=/636x0:1254x618/fit-in/500x500/99designs-contests-attachments/71/71552/attachment_71552376',
    search: '?pub_brand=Yumiko',
  },
  {
    name: 'Mariia',
    image:
      'https://images-platform.99static.com//em8fXuFGVJOGTE0mVgfyU1A4zIs=/300x153:938x791/fit-in/500x500/99designs-contests-attachments/78/78081/attachment_78081570',
    search: '?pub_brand=Mariia',
  },
];

function SectionFeaturedBrand(props) {
  const { intl, isMobileLayout, sliderSettings } = props;

  return (
    <div className={classNames(css.sectionFeaturedListing, css.sectionFeaturedBrand)}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>Shop by Brand</h2>
          </div>
        </div>
        <div className={css.featuredBrandsSec}>
          <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
            {featuredBrands.map((brand, index) => (
              <FeaturedBrandCard key={index} brand={brand} />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
} // Default slider settings
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 2,
        dots: true,
        arrows: false,
      },
    },
  ],
};

// Assign default props
SectionFeaturedBrand.defaultProps = {
  sliderSettings,
};

export default SectionFeaturedBrand;
